import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { LEAK_QUESTIONS, leakDefaults, leakReport, type LeakInputs } from "@/lib/tools/calc";
import { ToolPageShell, toolHead } from "@/components/site/tools/ToolPageShell";
import { LeakChart } from "@/components/site/tools/ToolCharts";

export const Route = createFileRoute("/tools/revenue-leakage-check")({
  head: () => toolHead("revenue-leakage-check"),
  component: LeakagePage,
});

function LeakagePage() {
  const [i, setI] = useState<LeakInputs>(leakDefaults);
  const n = i.answers.filter(Boolean).length;
  const set = (k: number, v: boolean) => setI((p) => ({ answers: p.answers.map((a, j) => (j === k ? v : a)) }));
  return (
    <ToolPageShell
      slug="revenue-leakage-check"
      report={leakReport(i)}
      inputs={i}
      chart={<LeakChart inputs={i} />}
      form={
        <div>
          <div className="mb-5">
            <div className="flex justify-between text-sm text-charcoal"><span>Likely leaks</span><span className="font-semibold text-midnight">{n} of 9</span></div>
            <div className="mt-2 h-2 overflow-hidden rounded-full bg-border" role="progressbar" aria-label="Likely leaks" aria-valuemin={0} aria-valuemax={9} aria-valuenow={n}>
              <div className="h-full rounded-full bg-midnight transition-all" style={{ width: `${(n / 9) * 100}%` }} />
            </div>
          </div>
          <ol className="space-y-3">
            {LEAK_QUESTIONS.map((q, k) => (
              <li key={q.q}>
                <fieldset className="rounded-xl border border-border bg-surface p-4">
                  <legend className="sr-only">Question {k + 1}</legend>
                  <p className="text-sm font-medium text-foreground">{k + 1}. {q.q}</p>
                  <div className="mt-3 flex gap-2">
                    {[true, false].map((v) => (
                      <label key={String(v)} className={`inline-flex min-h-10 cursor-pointer items-center gap-2 rounded-full border px-4 text-sm font-semibold focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-ring ${i.answers[k] === v ? "border-midnight bg-midnight text-frost" : "border-border bg-card text-midnight"}`}>
                        <input type="radio" name={`leak-${k}`} className="sr-only" checked={i.answers[k] === v} onChange={() => set(k, v)} />
                        {v ? "Yes" : "No"}
                      </label>
                    ))}
                  </div>
                </fieldset>
              </li>
            ))}
          </ol>
        </div>
      }
    />
  );
}
